<script>
  import axios from "axios";
  import * as ls from "local-storage";
  import config from "../stores/config";

  export let _id;
  export let fullname;
  export let tel;
  export let email;
  export let country;
  export let address;
  export let city;
  export let passport;
  export let category;

  const numberCalled = () => {
    axios
      .post(
        `${$config.backendURL}/callreports/${_id}`,
        {},
        {
          headers: { authorization: ls.get("jwt") },
        }
      )
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };
</script>

<div
  class="px-4 py-4 rounded-md shadow-sm bg-gradient-to-r from-gray-50 to-gray-100 relative"
>
  <div class="flex justify-between">
    <div class="flex items-center">
      <a
        target="_blank"
        class="flex items-center justify-center rounded-lg shadow-sm py-1 px-3 bg-gradient-to-r from-brand-white to-gray-50"
        on:click={numberCalled}
        href={`tel:+${tel.replace("+", "").replaceAll("-", "")}`}
      >
        <ion-icon name="call" class="text-2xl" />
      </a>
      <h1 class="font-semibold uppercase ml-2">
        {fullname}
      </h1>
    </div>
    {#if passport}
      <div class="ml-4 shadow-sm rounded-sm w-20 h-20 overflow-hidden">
        <img src={passport.path} alt="" class="w-20 h-20 object-cover" />
      </div>
    {/if}
  </div>

  <div class="expanded-menu border-t border-gray-100 pt-4">
    <h1 class="pb-2">
      Telephone:
      <a
        target="_blank"
        on:click={numberCalled}
        href={`tel:+${tel.replace("+", "").replaceAll("-", "")}`}
      >
        {tel}
      </a>
    </h1>

    <h1
      class="text-sm tracking-wider uppercase text-green-600 flex items-center mb-2"
    >
      <ion-icon name="globe" class="text-2xl mr-2" />
      — {country} / {category}
    </h1>

    <h1
      class="text-sm tracking-wider lowercase text-blue-500 flex items-center mb-2"
    >
      <ion-icon name="at-circle" class="text-2xl mr-2" />
      — {email}
    </h1>

    <h1 class="mt-3 text-gray-500">
      {city}, {address}
    </h1>

    <div class="mt-3 grid grid-cols-3 gap-3">
      <a
        target="_blank"
        class="flex items-center justify-center rounded-lg shadow-sm py-1 px-3 bg-gradient-to-r from-brand-white to-gray-50"
        on:click={numberCalled}
        href={`tel:+${tel.replace("+", "").replaceAll("-", "")}`}
      >
        <ion-icon name="call" class="text-2xl" />
      </a>
      <a
        target="_blank"
        class="shadow-sm flex items-center justify-center rounded-lg py-1 px-3 bg-gradient-to-r from-brand-white to-gray-50"
        href={`https://wa.me/${tel
          .replace("+", "")
          .replaceAll("-", "")
          .replaceAll(" ", "")}`}
      >
        <ion-icon name="logo-whatsapp" class="text-2xl" />
      </a>
      <a
        target="_blank"
        class="shadow-sm flex items-center justify-center rounded-lg py-1 px-3 bg-gradient-to-r from-brand-white to-gray-50"
        href={`mailto:${email}`}
      >
        <ion-icon name="mail" class="text-2xl" />
      </a>
    </div>
  </div>
</div>
